import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { getAlertEvents, acknowledgeAlert } from "@/api/alerts";

export function useAlertEvents(params?: { acknowledged?: boolean; severity?: string }) {
  return useQuery({
    queryKey: ["alert-events", params],
    queryFn: () => getAlertEvents(params),
    staleTime: 10_000,
    refetchOnWindowFocus: true,
  });
}

export function useAcknowledgeAlert() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: number) => acknowledgeAlert(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ["alert-events"] }),
  });
}
